





















import classList from './_comps/classList.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  components: { classList }
})
export default class BookList extends Vue {
  limit: number = 10
  loading: boolean = false
  subClass: any = null // 所有子分类
  audio_track: any = "全部" // 分类下默认选中的
  albumList: any = [] // 分类下专辑的内容
  if_more: boolean = true // 是否有下一页
  async mounted() {
    await this.getSubClass()
  }
  async getSubClass() {
    let res = await this.sendRequest()
    this.subClass = res.data.audio_tracks
  }
  async infiniteLoad() {
    if (!this.if_more) return
    await this.sendRequest()
  }
  async subTabList(index) {
    this.audio_track = this.subClass[index]
    this.albumList = []
    await this.sendRequest()
  }
  async sendRequest() {
    if (this.loading) return
    let res = await this.$axios.get(`/api/mobile/audios/resource2/albumCategory`, {
      // loading: r => this.loading = !!r,
      params: {
        id: this.$route.params.catId,
        audio_track: this.audio_track,
        offset: this.albumList.length,
        limit: this.limit
      }
    })
    this.if_more = res.data.albums.length !== 0
    this.albumList = [...this.albumList, ...res.data.albums]
    return res
  }
}
